import { render, staticRenderFns } from "./AddPhysicalExam.vue?vue&type=template&id=f4a5645c&scoped=true"
import script from "./AddPhysicalExam.vue?vue&type=script&lang=js"
export * from "./AddPhysicalExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a5645c",
  null
  
)

export default component.exports